function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 33,
  height: 23,
  rx: 3.5,
  fill: "none",
  stroke: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "card",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "shape",
  fill: "#0165AC",
  d: "M12 2.02V2h5v.02a7.5 7.5 0 0 1 0 14.96V17h-5v-.02a7.5 7.5 0 0 1 0-14.96z"
}), /*#__PURE__*/React.createElement("path", {
  id: "shape",
  fill: "#FFFFFF",
  d: "M14 13.74a4.5 4.5 0 0 0 0-8.48v8.48zm-3-8.48a4.5 4.5 0 0 0 0 8.48V5.26zM12.5 16a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13z"
}));

var SvgDiners = function SvgDiners(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiners, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Diners.32aed9e2.svg";
export { ForwardRef as ReactComponent };